import { AnyAction, Dispatch } from 'redux';
import { authService } from '../../services/authService';
import { authActions } from './authSlice';
import { firebaseService } from '../../services/firebaseService';
import { openMessageModal } from '../../components/statusModal/messageModalActionCreators';

export const authActionCreators = {
    loadAuthUser: () => async (dispatch: Dispatch<any>) => {
        console.group('[DIAG] authActionCreators.loadAuthUser');
        try {
            dispatch(authActions.setLoading(true));
            dispatch(authActions.setInitializing());
            let authUser = null;
            let isAuthenticated = false;
            const isAdmin = true; // TODO: replace this with actual check
            const currentUser = firebaseService.auth().currentUser;
            console.log('Firebase currentUser:', currentUser ? { uid: currentUser.uid, email: currentUser.email } : null);
            const accessToken = await currentUser?.getIdToken();
            console.log('accessToken obtained:', !!accessToken);
            if (accessToken) {
                authUser = await authService.getAuthUser();
                console.log('authUser from /auth:', authUser ? { Id: authUser.Id, Email: authUser.Email, SalesforceId: authUser.SalesforceId, Verified: authUser.Verified, Admin: authUser.Admin } : null);
                isAuthenticated = authUser != null;
                console.log('isAuthenticated:', isAuthenticated);

                if (isAuthenticated && (authUser!.FirstName === null && authUser!.LastName === null && authUser!.PhoneNumber === null)) {
                    console.log('Early return: incomplete profile (FirstName, LastName, PhoneNumber all null)');
                    console.groupEnd();
                    dispatch(authActions.setInitialized({authUser, isAuthenticated, isAdmin}));
                    return;
                }
            } else {
                console.log('No access token - user not signed in to Firebase');
            }
            console.groupEnd();
            return dispatch(authActions.setInitialized({authUser, isAuthenticated, isAdmin}));
        } catch (error) {
            console.error('[DIAG] loadAuthUser ERROR:', (error as any)?.message, (error as any)?.stack);
            console.groupEnd();
            dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
            dispatch(authActions.setErrorInitializing());
            console.error(error);
        } finally {
            dispatch(authActions.setLoading(false));
        }
    },

    initializeAuth: () => async (dispatch: Dispatch<any>) => {
        dispatch(authActionCreators.loadAuthUser());
    }
}